import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/auth-module/rl-logo.svg'


const _hoisted_1 = { class: "bg-white flex gap-6 h-screen grid grid-cols-1 lg:grid-cols-2" }
const _hoisted_2 = { class: "flex flex-col mt-[6rem] items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "w-12 h-12"
}, null, -1)
const _hoisted_4 = { class: "text-3xl font-semibold mt-5" }
const _hoisted_5 = { class: "font-normal text-base mt-1" }
const _hoisted_6 = { class: "w-[50%]" }
const _hoisted_7 = { class: "flex justify-start mt-4 px-1 font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex justify-center mt-5" }
const _hoisted_11 = { class: "text-sm text-[#475467] font-normal" }
const _hoisted_12 = ["src"]

import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import { auth } from "@/utils/firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

import backgroundSvg from "@/assets/auth-module/right-side-bg.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const backgroundImageStyle = `background-image: url('${backgroundSvg}')`;

const userStore = useUserStore();

const googleSignUp = async () => {
  const provider = new GoogleAuthProvider();

  signInWithPopup(auth, provider)
    .then(async (result) => {
      const user_id = result.user.uid;

      let respose = await userStore.googleLogin(user_id);

      // if(respose) {
      //   router.push('/main/overview');
      // } else {
      //   alert("Password and username are incorrect...");
      // }
      //redirect to login page as user has been authenticated
      // router.push('/auth/login');
    })
    .catch((error) => {
      console.log("Error: ", error);
    });
};

const forgotPassword = () => {
  router.push("/auth/forgot-password");
};

const GoToComplete = () => {
  router.push("/auth/complete-registration");
};

const handleSubmit = async (value: any) => {
  let response = await userStore.login(value);

  if (!response) {
    alert("Password or username are incorrect...");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("login_view.title")), 1),
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("login_view.sub_title")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "login-form",
          actions: false,
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              name: "email",
              type: "email",
              label: _ctx.$t('login_view.email_label'),
              validation: "required|email",
              "outer-class": "my-4 ",
              "input-class": "w-full h-11 mt-1 border-1 border-[#D0D5DD]",
              "label-class": "text-[#344054] font-medium",
              placeholder: _ctx.$t('login_view.email_placeholder'),
              "validation-messages": {
              required: _ctx.$t('login_view.email_required'),
              length: _ctx.$t('login_view.email_length'),
            }
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createVNode(_component_FormKit, {
              name: "password",
              label: _ctx.$t('login_view.password_label'),
              type: "password",
              validation: "required|length:6",
              "outer-class": "mt-4 w-full",
              "input-class": "w-full h-11 pr-[25%] mt-1",
              "label-class": "text-[#344054] font-medium",
              placeholder: _ctx.$t('login_view.password_placeholder'),
              "validation-messages": {
              required: _ctx.$t('login_view.password_required'),
              length: _ctx.$t('login_view.password_length'),
            }
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                class: "font-bold text-sm text-[#155EEF] cursor-pointer",
                onClick: forgotPassword
              }, _toDisplayString(_ctx.$t("login_view.forgot_password")), 1)
            ]),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "w-full h-11 opacity-50 font-semibold text-base text-white rounded-[20px] mt-6",
              inputClass: "mt-4 px-6 py-[10px] bg-[#155EEF]"
            }, {
              default: _withCtx(() => [
                (_unref(userStore).loader.login)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createVNode(_component_spinner_loader),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("login_view.btn_sign_in")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("login_view.btn_sign_in")), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t("login_view.dont_have_account")) + " ", 1),
            _createElementVNode("a", {
              onClick: GoToComplete,
              class: "text-sm cursor-pointer font-semibold text-[#155EEF]"
            }, _toDisplayString(_ctx.$t("login_view.sign_up")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: "flex items-end rounded-tl-[80px] rounded-bl-[80px] bg-no-repeat bg-cover bg-center",
      style: backgroundImageStyle
    }, [
      _createElementVNode("img", {
        src: require('@/assets/auth-module/man-image.png'),
        class: "w-full",
        alt: "Man Image"
      }, null, 8, _hoisted_12)
    ])
  ]))
}
}

})